

export const altImage = "https://blog.bozemancvb.com/hubfs/DSC_6505.jpeg";